import { CheckboxInputController } from './checkbox-input.controller'

const component = {
  templateUrl: '/workflow/components/checkbox-input/checkbox-input.html?$$REVISION$$',
  bindings: {
    field: '<',
    readOnly: '<',
    variations: '<', // space-delimited
    onChange: '&'
  },
  controllerAs: '$ctrl',
  controller: CheckboxInputController
}

export const checkboxInput = component
